import CustomButton from "components/button/custom_button";
import { useNavigate } from "react-router-dom";
import logoImg from "assets/img/home/logo.png";

const CustomHeader = (props) => {
  const { type } = props;
  const navigate = useNavigate();
  return (
    <div className={type === 1 ? "grid md:grid-cols-2" : "lg:col-span-2"}>
      <div className="flex items-center">
        <a href="/">
          <img src={logoImg} className="mb-3 h-24" alt="" />
        </a>
        <div className="mx-2 hidden h-14 w-0.5 bg-gray-500 lg:block"></div>
        <p
          className={
            "hidden lg:block " +
            (type === 1 ? "font-[700]" : "font-[800] text-white")
          }
        >
          СУРГАЛТЫН <br />
          МЕНЕЖМЕНТИЙН <br />
          СИСТЕМ <br />
        </p>
      </div>

      {type === 1 ? (
        <div className="flex items-center justify-end">
          <CustomButton
            onClick={() => {
              navigate("/auth");
            }}
            text="Нэвтрэх"
            className="m-2 ml-2 h-14 flex-none"
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default CustomHeader;
